
import type * as Dialog from '@radix-ui/react-dialog';
import { ConfirmDialog } from '@ui/uikit/components/common/Dialog';

type Props = Dialog.DialogProps & {
  onConfirm?: () => void;
};

export const ConfirmConnectModal = ({ onConfirm, ...props }: Props) => {
  return (
    <ConfirmDialog
      onConfirm={onConfirm}
      title="Notice"
      description="Once you receive a Gitcoin score for this wallet, you won't be able to transfer it to another account."
      {...props}
    />
  );
};
